import {
  type CategoryApiResponse,
  type CategoryTabOptions,
  type FaqApiResponse,
  type FaqResponse,
  type Filters,
} from '~/features/faq/types/faq'
import { END_POINTS, get } from '~/shared/http-client/api'

export const getFaqCategoryList = async (): Promise<CategoryTabOptions[]> => {
  const response: CategoryApiResponse = await get(END_POINTS.faq.category)

  const categoryList = response.data.categoryList
    .sort((a, b) => a.sorting - b.sorting)
    .map((category) => ({
      value: category.code,
      label: category.description,
    }))

  return categoryList
}

export const getFaqList = async (filters: Filters): Promise<FaqResponse> => {
  const params = new URLSearchParams({
    page: filters.page.toString(),
    row_per_page: filters.row_per_page.toString(),
    category_code: filters.category_code,
  })

  const response: FaqApiResponse = await get(
    `${END_POINTS.faq.list}?${params.toString()}`,
  )

  return response.data
}
